import { makeStyles, Menu } from "@material-ui/core";
import React from "react";
import FlexColumn from "../../../components/FlexBox/FlexColumn";

const useStyles = makeStyles(() => ({
    paper: (props) => ({
        border: "1px solid var(--grey100)",
        padding: "1rem",
        fontFamily: "Plus Jakarta Sans",
        borderRadius: "1rem",
        boxShadow: "0 32px 64px -12px color-mix(in srgb,var(--grey300) 74%,black)",
        fontWeight: 700,
        minWidth: "14rem",
        width: "fit-content",
        marginLeft: "3.5rem",
        position: "relative",
        overflow: "visible",
        background: 'var(--statew1)',
        ...props?.paperStyles,

        "&::before": {
            content: '""',
            position: "absolute",
            left: "-0.6rem",
            top: "50%",
            transform: "translateY(-50%)",
            width: "0.5rem",
            height: "1rem",
            background: 'var(--statew1)',
            clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
            boxShadow: `0 0 2px color-mix(in srgb, var(--grey800) 33%, transparent)`,
            ...props?.paperBeforeStyles,
        },
    }),
    list: { padding: "0rem" },
}));

const NavMenu = ({ anchorRef, open, onClose, styles = {}, transformOrigin = { vertical: 'center', horizontal: 'right' }, anchorOrigin = { vertical: 'center', horizontal: 'right' }, children }) => {

    const classes = useStyles(styles);

    const wrappedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            const originalOnClick = child.props.onClick;
            return React.cloneElement(child, {
                onClick: (event) => {
                    if (originalOnClick) {
                        originalOnClick(event); // keep original behavior
                    }
                    onClose(); // close menu
                }
            });
        }
        return child;
    });

    return (
        <Menu
            anchorEl={anchorRef.current}
            keepMounted
            open={open}
            getContentAnchorEl={null}
            transformOrigin={transformOrigin}
            anchorOrigin={anchorOrigin}
            classes={{ paper: classes.paper, list: classes.list }}
            onClose={onClose}
        >
            <FlexColumn flexWrap="nowrap" gap="0.25rem">
                {wrappedChildren}
            </FlexColumn>
        </Menu>
    );
};

export default NavMenu;